var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("cost-centre-menu"),
      _c(
        "v-row",
        { staticStyle: { "margin-bottom": "15px" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("global.search"),
                  "append-icon": "search",
                  "hide-details": "",
                  "single-line": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "div",
            [
              _c(
                "cost-centre-form",
                { on: { saved: _vm.load } },
                [
                  _c("v-btn", { attrs: { block: "", color: "accent" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("settings.costCentre.newCostButton")) + " "
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.costCentres,
          search: _vm.search,
          "sort-by": "list_order",
          "item-key": "id"
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("tr", [
                  _c(
                    "td",
                    { staticClass: "text-left" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            disabled: item.list_order === 1,
                                            icon: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.moveUp(item)
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [
                                          _vm._v("fa-arrow-alt-circle-up")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.moveUp")) + " ")]
                      ),
                      _vm._v(" " + _vm._s(item.list_order) + " "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            disabled:
                                              item.list_order ===
                                              _vm.costCentres.length,
                                            icon: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.moveDown(item)
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [
                                          _vm._v("fa-arrow-alt-circle-down")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.moveDown")) + " ")]
                      )
                    ],
                    1
                  ),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(" " + _vm._s(item.name) + " ")
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    item.is_enabled === 1
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("global.yes")))])
                      : _vm._e(),
                    item.is_enabled === 0
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("global.no")))])
                      : _vm._e()
                  ]),
                  _c(
                    "td",
                    {
                      staticClass: " justify-center align-content-center px-0"
                    },
                    [
                      item.used_in_delegations > 0
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "settings.costCentre.costEditAppliesNTimes",
                                  item.used_in_delegations,
                                  { count: item.used_in_delegations }
                                )
                              ) + " "
                            ),
                            _c("br")
                          ])
                        : _vm._e(),
                      item.used_in_delegations === 0
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("settings.costCentre.costZeroTimes")
                              )
                            ),
                            _c("br")
                          ])
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "td",
                    { staticClass: "px-0 text-center" },
                    [
                      _c("cost-centre-form", {
                        attrs: { "cost-centre": item },
                        on: {
                          "update:costCentre": function($event) {
                            item = $event
                          },
                          "update:cost-centre": function($event) {
                            item = $event
                          },
                          saved: _vm.load
                        }
                      }),
                      item.used_in_delegations === 0
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.remove(item)
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [_c("v-icon", [_vm._v("delete")])],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("global.delete")) + " "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }